import { api } from "@/lib/orgApi";

export const DEMO_NPI_SYSTEM = "urn:emrbymd:v3:demo-npi";
export const DEMO_NPI_VALUE = "DEMO";

export function formatCityStateZip(address) {
  if (!address) return "";
  const cityState = [address.city, address.state].filter(Boolean).join(", ");
  const postal = (address.postalCode || "").trim();
  if (cityState && postal) return `${cityState} ${postal}`;
  return cityState || postal;
}

export function formatCorrespondenceName({ firstName, lastName, credentials } = {}) {
  const creds = (credentials || "").trim();
  const prefix = creds === "MD" || creds === "DO" ? "Dr." : "";
  const name = [prefix, firstName, lastName].filter(Boolean).join(" ").trim();
  if (name && creds) return `${name}, ${creds}`;
  return name || creds;
}

export function formatReferringProviderCorrespondence(provider) {
  if (provider?.correspondenceBlock) return provider.correspondenceBlock;
  const address = provider?.address || {};
  return [
    formatCorrespondenceName(provider || {}),
    provider?.organization,
    ...(address.line || []),
    formatCityStateZip(address),
  ]
    .filter(Boolean)
    .join("\n");
}

export async function listReferringProviders({ q, active } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  const { data } = await api.get("/referring-providers", { params });
  return data;
}

export async function getReferringProvider(providerId) {
  const { data } = await api.get(
    `/referring-providers/${encodeURIComponent(providerId)}`,
  );
  return data;
}
